<template>
  <div>
    <!-- comment sort bar start-->
    <comment-sortbar
      ref="commentSortbar"
      :isFilterApplied="isFilterApplied"
      :sortbarData="sortbarFilterData"
      @toggleFilter="toggleFilter"
      @getComment="getComment"
      @resetFilters="resetFilters"
    ></comment-sortBar>
    <!-- comment sort bar end-->
    <comment-openfilter
      ref="filterComment"
      @allComment="allComment"
      @totalResponses="totalResponsesCount"
      @sortbarData="sortbarData"
      @onGetComments="onGetComments"
    ></comment-openfilter>

    <comments-Filters
      ref="CommentsFilters"
      reportType="comments"
      @getReportWithFilter="filterApplied"
    ></comments-Filters>

    <v-row class="ma-4">
      <!-- <v-col cols="4" style="height:55vh;overflow-y:hidden; padding:10% 5%;"> -->
      <v-col cols="4">
        <v-icon class="comment" style="font-size:35px">las la-comment</v-icon>
        <p class="headline mb-0">Comments</p>
        <small class="">See what your employees have to say about the
organization through this open-ended Q&A response repository. Amara

takes into account various employee sentiments before prompting them an
open-ended question.</small>
      </v-col>
      <v-col cols="8">
        <strong class="ml-2">Highlighted comments({{totalComments}})</strong>
        <v-row class="text-center" v-if="totalComments === 0">
          <div class="box-container w-100 py-4 mt-4">
            <strong class="body-2 font-weight-bold grey--text">
              No comments available
            </strong>
          </div>
        </v-row>
        <!-- <v-row style="height:58vh; overflow-y:auto;" class="pa-2"> -->
        <div class="comments-wrap infinite-wrapper">
          <v-row class="ma-2 mt-0" v-if="totalComments > 0">
            <v-col cols="12" class="box-container overflow-hidden my-2 mt-0 pa-0" v-for="(comment, c) in filteredComment" :key="c">
              <div v-if="comment.is_sensitive" class="pa-2 pt-0" style="background: rgb(172 155 197 / 32%); min-height:40px;">
                <p class="mb-0" style="font-size:80%;">Detected words:
                  <v-chip
                    v-for="(word, w) in comment.sensitive_words" :key="w"
                    class="ma-2"
                    x-small
                  >
                    {{word}}
                  </v-chip>
                </p>
              </div>
              <v-divider v-if="comment.is_sensitive"></v-divider>
              <div class="pa-2">
                <v-row>
                  <v-col cols="1" class="py-0">
                    <div style="width:40px; height:40px; border:1px solid #ccc; border-radius:100%; position:relative; text-align:center;padding-top:8px;">
                      <span style="font-weight:bold; font-size:18px;" v-if="comment.parent_response_rating">{{comment.parent_response_rating}}</span>
                      <span style="font-weight:bold; font-size:14px;" v-if="comment.parent_response_rating">/5</span>
                      <span style="font-weight:bold; font-size:16px;" v-if="!comment.parent_response_rating">--</span>
                    </div>
                  </v-col>
                  <v-col cols="8" class="py-0">
                    <p class="mb-0" style="font-weight:bold; font-size:80%;">{{comment.interaction_parent_question}}</p>
                    <p class="mb-0 mt-1" style="font-weight:bold; color:grey; font-size:80%;">{{dayjs(comment.createdAt).format('DD-MM-YYYY')}} &#8226; <span v-if="comment.interaction_driver"> Driver : <v-chip small>{{comment.interaction_driver}}</v-chip> &#8226; </span> <span v-if="comment.interaction_sub_driver">Sub driver : <v-chip small>{{comment.interaction_sub_driver}}</v-chip> &#8226;</span>   <span style="cursor:pointer" @click="openEmployee(comment.user_profile_id)">{{comment.user_name}}</span> </p>
                  </v-col>
                  <v-col cols="3" class="py-0 d-flex justify-end">
                    <div style="font-size:12px;padding-right:2px" class="pt-1">
                      Response sentiment:
                    </div>
                    <div>
                      <v-chip style="float:right;" v-if="comment.response_sentiment < 0.5" color="rgba(244, 67, 54, 0.2)" class="" small>Negative</v-chip>
                      <v-chip style="float:right;" v-if="comment.response_sentiment == 0.5" color="rgba(246, 251, 252, 1)" class="" small>Neutral</v-chip>
                      <v-chip style="float:right;" v-if="comment.response_sentiment > 0.5" color="rgba(100, 231, 100, 0.2)" class="" small>Positive</v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" class="pb-0">
                    <v-row no-gutters>
                      <v-col cols="1"></v-col>
                      <v-col cols="11">
                        <p class="mb-0" style="">{{comment.formatted_response}}</p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" spinner="waveDots" force-use-infinite-wrapper=".infinite-wrapper">
            <span slot='no-more'>{{' '}}</span>
            <span slot='no-results'>{{' '}}</span>
          </infinite-loading>
        </div>
        <!-- Pagination -->
        <!-- <div class="d-flex" v-if="filteredComment.total_responses > 0">
          <v-flex xs1></v-flex>
          <v-flex class="pr-4 mb-0 ml-3" xs10 style="text-align:center">
            <v-pagination
              class="adhoc--text"
              color="adhoc"
              v-model="pagination.page"
              :length="pagination.length"
              @input="getStages()"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs1></v-flex>
        </div> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
/*eslint-disable*/
import Vue from 'vue';
import { mapState } from 'vuex';
// import { ContentLoader } from 'vue-content-loader';
import axios from 'axios';
// import { VChip, VMenu, VSubheader } from 'vuetify';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import InfiniteLoading from 'vue-infinite-loading';
import CommentSortbar from './comment-sortbar';
import CommentOpenfilter from './comment-openfilter';
import CommentsFilters from './comments-filter';

dayjs.extend(relativeTime);

Vue.prototype.$http = axios;

export default {
  name: 'commnets',
  components: {
    // Qriousl
    CommentsFilters,
    CommentSortbar,
    CommentOpenfilter,
    InfiniteLoading
  },
  data () {
    return {
      allCommentActive: true,
      isFilterApplied: false,
      sensitiveCommentActive: false,
      filteredComment: [],
      pagination: {
        rowsPerPage: 10,
        page: 1,
        length: 1
      },
      questionFilters: {},
      infiniteId: new Date(),
      sortbarFilterData: {},
      totalComments: 0
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  
  methods: {
    infiniteHandler ($state) {
      this.$refs.filterComment.getComments($state);
    },
    onGetComments () {
      this.pagination.page = 1;
      this.filteredComment = [];
      this.infiniteId += 1;
    },
    totalResponsesCount (val) {
      // console.log("totalResponsesCount -> val", val);
      // total_responses
      this.totalComments = val;
    },
    sortbarData (data) {
      this.sortbarFilterData = {};
      this.sortbarFilterData = data;
      // return data;
      // console.log('data', data);
    },
    openEmployee (id) {
      this.$router.push(`/employees/view/${id}`);
    },
    toggleFilter () {
      if (this.$refs.CommentsFilters) {
        this.$refs.CommentsFilters.showFilterDrawer = !this.$refs.CommentsFilters.showFilterDrawer;
      }
    },
    allComment (val) {
      this.filteredComment = val;
      // allComment
      this.pagination.length = Math.ceil(this.filteredComment.total_responses / this.pagination.rowsPerPage);
    },
    // getAllComment (val) {
      // this.allCommentActive = true;
      // this.sensitiveCommentActive = false;
      // this.$refs.filterComment.getCommentsType(false);
      // this.$refs.filterComment.getComments();
    // },
    resetFilters () {
      this.isFilterApplied = false;
      this.$refs.CommentsFilters.resetFilters();
      this.$refs.filterComment.questionFilters = {};
      this.$router.push({
        path: '/comments'
      }).catch(() => {});
      this.filterApplied (false);
      // this.getComment(false);
    },
    filterApplied (val) {
      this.isFilterApplied = val;
      const type = this.$refs.commentSortbar.activeView;
      if (type === 'allComments') {
        this.getComment(false);
      } else {
        this.getComment(true);
      }
    },
    getComment (val) {
      this.$refs.filterComment.getCommentsType(val);
      this.$refs.filterComment.pagination.page = 1;
      this.$refs.filterComment.getComments();
    },
    // getSensetiveComment (val) {
    //   this.sensitiveCommentActive = true;
    //   this.allCommentActive = false;
    //   // console.log(this.$refs.filterComment);
    // },
    getStages () {
      this.$refs.filterComment.pagination.page = this.pagination.page;
      this.$refs.filterComment.getComments();
    }
  },

  watch: {
    company () {
      this.updateIntegrations();
    }
  },
  beforeMount () {
    // console.log(this.$refs);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.comments-wrap {
  height: 60vh;
  overflow: hidden;
  overflow-y: auto;
}
.top-nav {
  // position: relative;
  padding: 12px 12px 0;
  background: #050550;
  background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      position: relative;
      cursor: pointer;
      a {
        text-decoration: none;
      }
      .top-menu {
        // height: 55px;
        height: 48px;
        // border-top-left-radius: 0.375rem;
        border-top-left-radius: 0.5rem;
        // border-top-right-radius: 0.375rem;
        border-top-right-radius: 0.5rem;
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        // margin-right: 0.5rem;
        margin-right: 0.25rem;
        // color: var(--color-text);
        color: var(--bg);
        font-size: var(--content-size);
        position: relative;
        .top-menu__title {
          margin-left: 0.25rem;
          display: flex;
          align-items: center;
          white-space: nowrap;
          .top-menu__sub-icon {
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
            width: 1rem;
            height: 1rem;
            margin-left: 0.5rem;
          }
        }
        &.top-menu--active {
          display: flex;
          background-color: #faf8fb;
          color: var(--primary-color);
          .top-menu__icon {
            color: var(--primary-dark);;
          }
          .top-menu__title {
            color: var(--color-headings);
            font-weight: var(--heading-weight);
          }
          &::before {
            content: "";
            width: 20px;
            height: 20px;
            margin-left: -20px;
            transform: rotate(90deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &::after {
            content: "";
            width: 20px;
            height: 20px;
            margin-right: -20px;
            transform: rotate(180deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
        &:not(.top-menu--active) .top-menu__icon:before {
          content: "";
          z-index: -1;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          transition-property: background-color,
          border-color, color, fill, stroke, opacity, box-shadow, transform;
          transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
          transition-duration: 100ms;
        }
      }
      @keyframes intro-active-menu-animation {
        100% {
          z-index: 0;
        }
      }
      @keyframes intro-menu-animation {
        100% {
          opacity: 1;
          transform: translateX(0px);
        }
      }
      &:hover .top-menu:not(.top-menu--active) {
        // background-color: var(--bg-panel);
        background-color: var(--bg);
        background-color: #dde2e9;
        background-color: #fbfcff;
        background-color: #faf8fb;
        color: var(--primary-color);
      }
      &:hover .dropdown {
        display: block;
      }
      .dropdown {
        list-style: none;
        margin: 0;
        padding: 0.5rem !important;
        // background-color: var(--primary-dark);
        background: rgb(52,43,126);
        background: linear-gradient(150deg, rgba(52,43,126,1) 0%, rgba(84,72,189,1) 70%, rgba(143,72,189,1) 100%, rgba(197,36,55,1) 100%);
        -webkit-box-shadow: 0 3px 20px rgba(0,0,0,.04);
        box-shadow: 0 3px 20px rgba(0,0,0,.04);
        display: none;
        width: 100%;
        position: absolute;
        border-radius: .375rem;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        z-index: 20;
        li {
          cursor: pointer;
          position: relative;
          .top-menu-side {
            height: 55px;
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            display: flex;
            align-items: center;
            padding-left: 0;
            padding-right: 0;
            margin-right: 0;
            --text-opacity: 1;
            color: #fff;
            color: rgba(255, 255, 255, var(--text-opacity));
            position: relative;
            width: 100%;
            padding-left: 1.25rem !important;
            .top-menu__title {
              width: 100%;
              margin-left: 0.5rem;
              display: flex;
              align-items: center;
              white-space: nowrap;
              // color: #9f88f1;
              opacity: 0.75;
            }
            // .top-menu__icon:before {
            //   content: "";
            //   z-index: -1;
            //   position: absolute;
            //   width: 100%;
            //   height: 100%;
            //   top: 0;
            //   left: 0;
            //   border-radius: 0.5rem;
            //   transition-property: background-color,
            //   border-color, color, fill, stroke, opacity, box-shadow, transform;
            //   transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            //   transition-duration: 100ms;
            // }
          }
          &:hover .top-menu-side {
            color: var(--color-text);
            font-weight: var(--heading-weight);
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
          }
          &:hover {
            transition: 0.5s ease;
            .top-menu__title {
              color: var(--bg);
              opacity: 1;
            }
            background-color: rgba(0, 0, 0, 0.04);
          }
        }
      }
    }
  }
}
</style>
